import { render } from "./App.vue?vue&type=template&id=2efbfb9c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2efbfb9c&lang=css"

import exportComponent from "/Users/rguigsaad/Downloads/f&v/ladidate/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__